import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute left-1/2 top-1/2 block w-5 -translate-x-1/2 -translate-y-1/2" }


export default /*#__PURE__*/_defineComponent({
  __name: 'HamburgerButton',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "relative size-10 text-dynamicText focus:outline-none",
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        "aria-hidden": "true",
        class: _normalizeClass(["absolute block h-0.5 w-5 bg-current transition duration-500 ease-in-out", _ctx.isOpen ? 'rotate-45' : '-translate-y-1.5'])
      }, null, 2),
      _createElementVNode("span", {
        "aria-hidden": "true",
        class: _normalizeClass(["absolute block h-0.5 w-5 bg-current transition duration-500 ease-in-out", { 'opacity-0': _ctx.isOpen }])
      }, null, 2),
      _createElementVNode("span", {
        "aria-hidden": "true",
        class: _normalizeClass(["absolute block h-0.5 w-5 bg-current transition duration-500 ease-in-out", _ctx.isOpen ? '-rotate-45' : 'translate-y-1.5'])
      }, null, 2)
    ])
  ]))
}
}

})